import React, { useEffect } from "react";
import "./Delivery_boy.css";
import {
  faCircleUser,
  faCommentDots,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Delivery_boy = ({ order }) => {
  return (
    <>
      <section className="Delivery_boy_sec">
        <div className="row">
          <div className="col-8 p-1">
            <p className="del_partner">
              <FontAwesomeIcon icon={faCircleUser} />{" "}
              {order?.delivery_boy?.name} is Delivery Partner
            </p>
          </div>
          <div className="col-4 p-1">
            <div className="flex_icons">
              <a href="tel:+4733378901">
                <div className="icon_div">
                  <FontAwesomeIcon className="faicon" icon={faPhone} />
                </div>
              </a>
              <a href="tel:+4733378901">
                <div className="icon_div">
                  <FontAwesomeIcon className="faicon" icon={faCommentDots} />
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Delivery_boy;
